import { useLocation, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useStateContext } from '../../../Context/ContextProvider';

export default function Tabs() {
  const { counts } = useStateContext();

  // couleur actif
  const location = useLocation();
  const [activeColor, setActiveColor] = useState("disponible");
  useEffect(() => {
    if (location.pathname.includes("/cfp/catalogue/corbeille")) {
      setActiveColor("corbeille");
    } else if (location.pathname.includes("/cfp/catalogue/preparation")) {
      setActiveColor("preparation");
    } else {
      setActiveColor("disponible");
    }
  }, [location.pathname]);

  const tabClasses = (tab) =>
    `flex items-center gap-1 px-2 py-0.5 rounded-xl border border-gray-300 ${activeColor === tab ? "bg-purple-700 text-white" : "bg-white hover:bg-purple-300 "
    }`;

  const linkClasses = (tab) =>
    `font-semibold tracking-wide cursor-pointer text-[12px] px-3 py-1 rounded-full transition-colors duration-200 ${activeColor === tab ? "text-white" : "text-black  "
    }`;

  const countClasses = (tab) =>
    `flex items-center justify-center w-6 h-5 text-[12px] font-semibold border rounded-full ${activeColor === tab
      ? "bg-white text-purple-900 border-purple-800 "
      : "bg-gray-200 text-gray-600 border-gray-300  "
    }`;


  return (
    <ul className="flex space-x-1 bg-gray-100 p-1 rounded-lg shadow-sm">
      {/* <li className={tabClasses("disponible")} onClick={() => setActiveColor("disponible")}>
        <Link to={"cfp/catalogue"}
          className={linkClasses("disponible")}
        >
          <span>Formations disponibles</span>
          <div className={countClasses("disponible")}>
            {counts.online || 0}
          </div>
        </Link>

      </li> */}
      {/* <li className={tabClasses("preparation")} onClick={() => setActiveColor("preparation")}>
        <Link to={`/cfp/catalogue/preparation`}
          className={linkClasses("preparation")}
        >
          En préparation
        </Link>
        <div className={countClasses("preparation")}>
          {counts.offline || 0}
        </div>
      </li>

      <li className={tabClasses("corbeille")} onClick={() => setActiveColor("corbeille")}>
        <Link to={`/cfp/catalogue/corbeille`}
          className={linkClasses("corbeille")}
        >
          En Corbeille
        </Link>
        <div className={countClasses("corbeille")}>
          {counts.trash || 0}
        </div>
      </li> */}

      <li>
        <Link
          to={`/cfp/catalogue`}
          className={`flex items-center gap-2 px-3 py-1 rounded-xl border border-gray-300 ${activeColor === "disponible"
            ? "bg-purple-700 text-white"
            : "bg-white hover:bg-purple-300"
            }`}
          onClick={() => setActiveColor("disponible")}
        >
          <span className="font-semibold tracking-wide text-[12px]">Formations disponibles</span>
          <div className={`flex items-center justify-center w-6 h-5 text-[12px] font-semibold border rounded-full ${activeColor === "disponible"
            ? "bg-white text-purple-900 border-purple-800"
            : "bg-gray-200 text-gray-600 border-gray-300"
            }`}>
            {counts.online || 0}
          </div>
        </Link>
      </li>

      <li>
        <Link
          to={`/cfp/catalogue/preparation`}
          className={`flex items-center gap-2 px-3 py-1 rounded-xl border border-gray-300 ${activeColor === "preparation"
            ? "bg-purple-700 text-white"
            : "bg-white hover:bg-purple-300"
            }`}
          onClick={() => setActiveColor("preparation")}
        >
          <span className="font-semibold tracking-wide text-[12px]">En préparation</span>
          <div className={`flex items-center justify-center w-6 h-5 text-[12px] font-semibold border rounded-full ${activeColor === "preparation"
            ? "bg-white text-purple-900 border-purple-800"
            : "bg-gray-200 text-gray-600 border-gray-300"
            }`}>
            {counts.offline || 0}
          </div>
        </Link>
      </li>

      <li>
        <Link
          to={`/cfp/catalogue/corbeille`}
          className={`flex items-center gap-2 px-3 py-1 rounded-xl border border-gray-300 ${activeColor === "corbeille"
            ? "bg-purple-700 text-white"
            : "bg-white hover:bg-purple-300"
            }`}
          onClick={() => setActiveColor("corbeille")}
        >
          <span className="font-semibold tracking-wide text-[12px]">En corbeille</span>
          <div className={`flex items-center justify-center w-6 h-5 text-[12px] font-semibold border rounded-full ${activeColor === "corbeille"
            ? "bg-white text-purple-900 border-purple-800"
            : "bg-gray-200 text-gray-600 border-gray-300"
            }`}>
            {counts.trash || 0}
          </div>
        </Link>
      </li>



    </ul>
  );
}
